import React, { useRef, useEffect, useState, useContext } from "react";
import { useSelector } from "react-redux";
import { jsonEditorContext } from "../../../Context/jsonEditorContext";
import ResumeSubUseForm from "../../../hooks/editor/resumeSubUseForm";
import { useTranslation } from "react-i18next";
import ChangeResumeOrder from "../../../hooks/editor/changeResumeOrder";
import ContentEditable from "../../../Components/ContentEditable/ContentEditable";
import Quilleditor from "../../../Components/Quilleditor/Quileditor_New";
import SectionItemToolbar from "../../../Components/GlobalSectionToolbar/SectionItemToolbar";
import SectionHeader from "../SectionHeader/sectionHeader";
import SectionItemWrapper from "../SectionItemWrapper/SectionItemWrapper";
function CustomText(props) {
  const {
    resumeFields,
    sectionId,
    resumeTitleHandler,
    handleEditorChange,
    resumeHandler,
    resumeUpdate,
    dateHandler,
    styles,
    settings,
    handleSliderChange,
    PageMargin,
    SectionMargin,
    layout,
  } = props;
  const { selectedFont, primaryColor, secondaryColor, titleFont, bodyFont } =
    styles;
  const [t, i18n] = useTranslation("common");
  const { json, setJson, jsonIndex, setJsonIndex, isJson, setIsJson } =
    useContext(jsonEditorContext);

  const [showSettings, setShowSettings] = useState(false);
  const [focusIndex, setFocusIndex] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);

  const [showQuillToolbar, setShowQuillToolbar] = useState(true);

  const changesetShowQuillToolbar = (status) => {
    setShowQuillToolbar(status);
  };

  //UseForm

  const {
    handleDelete,
    sectionItemMoveUp,
    sectionItemMoveDown,
    showHideElements,
  } = ResumeSubUseForm(props.sectionId);

  const innerSectionClick = (e, index) => {
    props.changeFocusStyle(props.sectionId, index.toString(), "item");
  };

  useEffect(() => {
    setFocusIndex(false);
  }, []);

  const mainSectionClick = (e, title) => {
    props.changeFocusStyle(props.sectionId, false, "section");
  };

  const handleDatePicker = () => {
    setShowDatePicker(true);
  };

  return (
    <>
      {resumeFields && resumeFields.show && (
        <>
          <SectionHeader
            styles={styles}
            settings={settings}
            resumeFields={resumeFields}
            sectionId={sectionId}
            resumeTitleHandler={resumeTitleHandler}
            resumeUpdate={resumeUpdate}
            PageMargin={PageMargin}
            SectionMargin={SectionMargin}
          />
          <div className="section-item-wrapper customText-item-wrapper">
            {props &&
              props.response &&
              props.response.itemIndexes.map(
                (result, ind) =>
                  resumeFields &&
                  resumeFields.data &&
                  resumeFields.data.map((response, index, row) =>
                    index == result ? (
                      <SectionItemWrapper
                        sectionId={sectionId}
                        styles={styles}
                        layout={layout}
                        index={index}
                        newSectionFocus={props.newSectionFocus}
                        currentStateFocus={props.currentStateFocus}
                        newItemFocus={props.newItemFocus}
                        SectionMargin={SectionMargin}
                        onMouseDown={(e) => e.stopPropagation()}
                        onClick={(e) => {
                          e.stopPropagation();
                          innerSectionClick(e, index);
                        }}
                      >
                        {showQuillToolbar &&
                          props.newSectionFocus == props.sectionId &&
                          props.currentStateFocus == "item" &&
                          props.newItemFocus &&
                          props.newItemFocus == index.toString() && (
                            <>
                              <SectionItemToolbar
                                index={index}
                                indexString={index.toString()}
                                handleDelete={props.handleItemDelete}
                                sectionItemMoveUp={sectionItemMoveUp}
                                sectionItemMoveDown={sectionItemMoveDown}
                                addAdditionalField={props.addResumeField}
                                row={row}
                                sectionId={props.sectionId}
                                startFrom={response.startFrom}
                                endUntil={response.endUntil}
                                resumeUpdate={resumeUpdate}
                                dateHandler={dateHandler}
                                response={response}
                                changeSettings={props.changeSettings}
                                showDatePicker={showDatePicker}
                                className="ql-bold"
                                handleSliderChange={handleSliderChange}
                              />
                            </>
                          )}
                        <h4>
                          <ContentEditable
                            sectionId={sectionId}
                            name="title"
                            tagType="span"
                            className="pr-4"
                            index={index}
                            value={response.title}
                            placeholder="Title"
                            onChange={resumeHandler}
                            onBlur={resumeUpdate}
                            style={{
                              color: primaryColor,
                              fontFamily: bodyFont,
                              fontSize: selectedFont?.h3,
                              lineHeight: selectedFont?.h3_lineHeight,
                              fontWeight: 500,
                              paddingBottom: "5px",
                            }}
                          />
                        </h4>
                        {response &&
                          response.showFields &&
                          response.showFields.description && (
                            <div className="customText-description resume-description">
                              <Quilleditor
                                type="visual"
                                showQuillToolbar={showQuillToolbar}
                                changesetShowQuillToolbar={
                                  changesetShowQuillToolbar
                                }
                                theme="snow"
                                className={``}
                                inivalue={response?.description?.replace(
                                  /\n|\r/g,
                                  ""
                                )}
                                current={index}
                                setvalue={handleEditorChange}
                                onBlur={resumeUpdate}
                                styles={styles}
                                sectionId={props.sectionId}
                                placeholder="Whats the one thing that you want someone to remember to after reading your resume?"
                              />
                            </div>
                          )}
                      </SectionItemWrapper>
                    ) : (
                      ""
                    )
                  )
              )}
          </div>
        </>
      )}
    </>
  );
}

export default CustomText;
